'use client';

import { ChatMessage } from '@chewy/chat-library-common';
import styles from './AgentDisconnectedIndicator.module.scss';
import { formatTimeWithLowercaseAMPM } from '@chewy/chat-library-common';

export interface AgentDisconnectedMessage {
  /** Timestamp when agent disconnected */
  timestamp: string;
  /** Agent information */
  agent: {
    displayName: string;
    /** Team name (defaults to "Customer Care Team") */
    teamName?: string;
  };
}

export interface AgentDisconnectedIndicatorProps {
  /** The widget data from structured message */
  data?: AgentDisconnectedMessage | AgentDisconnectedMessage[];
  /** The message from structured message */
  message?: ChatMessage;
}

export default function AgentDisconnectedIndicator({ data, message }: AgentDisconnectedIndicatorProps) {
  // Extract the first item if data is an array
  const disconnectedData = Array.isArray(data) ? data[0] : data;

  const agent = disconnectedData?.agent;
  const agentName = agent?.displayName ?? '';
  const timestamp = message?.responseTimestamp ?? '';
  const formattedTime = formatTimeWithLowercaseAMPM(timestamp);

  return (
    <div className={styles.container}>
      <span className={styles.text}>{agentName} left chat at {formattedTime}</span>
    </div>
  );
}
